module.exports = __webpack_public_path__ + "img/brl_logo.83b3c170.svg";